let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cBn9x")).then(() => parcelRequire('8sGfb'));